export default {
   badge: "پشتیبانی و تماس",
    title: "ارسال پیام",
    subtitle: "در صورت نیاز به پشتیبانی فنی، مشکل در پرداخت و یا کسب اطلاعات بیشتر، پیام خود را با استفاده از فرم زیر ارسال نمایید.",
    formHeaderTitle: "ارسال پیام",
    formHeaderSub: "معمولاً در عرض چند ساعت پاسخ می‌دهیم.",
    fullNameLabel: "نام و نام خانوادگی",
    fullNamePlaceholder: "مثال: علی رضایی",
    phoneLabel: "شماره تماس",
    phonePlaceholder: "۰۹۱۲۰۰۰۰۰۰۰",
    subjectLabel: "موضوع",
    subjects: {
      support: "پشتیبانی فنی و دسترسی به دوره‌ها",
      payment: "مشکلات پرداخت و صورت‌حساب",
      courses: "مشاوره آموزشی و ثبت‌نام",
      other: "سوالات عمومی و پیشنهادات",
    },
    messageLabel: "متن پیام",
    messagePlaceholder: "توضیحات خود را اینجا بنویسید...",
    submitBtn: "ارسال پیام",
    sendingBtn: "در حال ارسال...",
    quickInfoTitle: "اطلاعات تماس",
    addressTitle: "دفتر مرکزی",
    addressVal: " تهران، خیابان انقلاب، خیابان 12 فروردین، نبش روانمهر، پلاک 256 ",
    phoneTitle: "پشتیبانی تلفنی",
    hoursTitle: "ساعات پاسخگویی",
    hoursVal: "شنبه تا چهارشنبه: ۹:۰۰ الی ۱۸:۰۰",

};
